module.exports = __webpack_public_path__ + "img/ChemistryEx.39c6057f.svg";